import { render, staticRenderFns } from "./organization-manage.vue?vue&type=template&id=016b09e5&scoped=true"
import script from "./organization-manage.vue?vue&type=script&lang=ts"
export * from "./organization-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b09e5",
  null
  
)

export default component.exports